import { LocalParticipant, LocalVideoTrack } from "twilio-video";

export const changeCamera = (
  localParticipant: LocalParticipant,
  device: string
): Promise<LocalVideoTrack> => {
  return new Promise<LocalVideoTrack>((resolve, reject) => {
    // Busca pelo track da camera
    const cameraTrack: LocalVideoTrack | undefined = Array.from(
      localParticipant.videoTracks.values()
    )
      .map((videoTrack) => videoTrack.track)
      .find((track) => track.name === "camera");

    // Restarta o track com o novo dispositivo
    if (cameraTrack) {
      cameraTrack.stop();
      cameraTrack
        .restart({ deviceId: { exact: device } })
        .then(() => {
          localStorage.setItem("SELECTED_VIDEO_DEVICE", device);
          resolve(cameraTrack);
        })
        .catch(() => {
          reject();
        });
    } else {
      reject();
    }
  });
};
